import { render, staticRenderFns } from "./requestDemo.vue?vue&type=template&id=2c2816ea&"
import script from "./requestDemo.vue?vue&type=script&lang=js&"
export * from "./requestDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports